import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';

const TELEGRAM_URL = 'https://t.me/advokattop_managment';
const DISMISS_KEY_PREFIX = 'supportGroupPopupDismissed_';

// Shown to every attorney on login and on every visit while already logged in,
// until they explicitly dismiss it — dismissal is per-account (keyed by user id)
// so it persists across future visits on this browser but not across accounts.
const SupportGroupPopup = () => {
  const { user, isAttorney, loading } = useAuth();
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (loading || !isAttorney || !user) return;
    if (!localStorage.getItem(DISMISS_KEY_PREFIX + user.id)) setVisible(true);
  }, [loading, isAttorney, user]);

  const dismissForever = () => {
    if (user) localStorage.setItem(DISMISS_KEY_PREFIX + user.id, '1');
    setVisible(false);
  };

  // Just closes this showing — reappears on the next visit, unlike dismissForever.
  const close = () => setVisible(false);

  if (!visible) return null;

  return (
    <div
      onClick={close}
      style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '1rem',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          position: 'relative', backgroundColor: 'white', borderRadius: '16px', padding: '2.25rem 2rem',
          maxWidth: '440px', width: '100%', textAlign: 'center',
          boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
        }}
      >
        <button
          onClick={close}
          aria-label="Close"
          style={{
            position: 'absolute', top: '0.75rem', right: '0.75rem',
            width: '32px', height: '32px', borderRadius: '50%', border: 'none',
            backgroundColor: '#f1f5f9', color: '#718096', fontSize: '1.1rem', lineHeight: 1,
            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          ×
        </button>
        <div style={{ marginBottom: '1rem', display: 'flex', justifyContent: 'center' }}>
          <svg width="52" height="52" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="120" cy="120" r="120" fill="#29A9EB"/>
            <path d="M170.6 72.7L54.4 118.1c-8.1 3.3-8.1 8-1.5 10l29.9 9.3 11.6 37.3c1.4 4.5 2.5 6.3 5.1 6.3 2 0 2.9-0.9 4-2l17.1-16.4 35.6 26.2c6.5 3.6 11.2 1.7 12.8-6l23.2-109.2c2.3-9.4-3.4-13.6-9.6-10.9z" fill="white"/>
          </svg>
        </div>
        <h2 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#1a365d', marginBottom: '0.75rem' }}>
          {t('supportGroup.title')}
        </h2>
        <p style={{ fontSize: '0.95rem', color: '#4a5568', lineHeight: '1.65', marginBottom: '1.5rem' }}>
          {t('supportGroup.body')}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              backgroundColor: '#29A9EB', color: 'white', textDecoration: 'none',
              padding: '0.85rem 1.5rem', borderRadius: '10px', fontSize: '0.95rem', fontWeight: 700,
            }}
          >
            {t('supportGroup.joinBtn')}
          </a>
          <button
            onClick={dismissForever}
            style={{
              backgroundColor: 'transparent', color: '#718096', border: 'none',
              padding: '0.5rem', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer',
            }}
          >
            {t('supportGroup.dontShowAgain')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupportGroupPopup;
